class DataProvider{
    // baseUrl = "http://localhost:5001/icomply-dev/us-central1/";
    baseUrl = "https://us-central1-icomply-dev.cloudfunctions.net/" ;
    // baseUrl = "http://e843-2405-201-200f-411c-3c41-974-a672-5a5c.ngrok.io/icomply-dev/us-central1/" ;
}


export default new DataProvider();